<p-dialog [(visible)]="display" header="Table Actions" modal="true" [draggable]="true" [resizable]="true"
  [closable]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ 'width': '60vw' }">
  <div *ngIf="!areRowsSelected" class="p-mb-1">
    <small>Select rows to enable bulk actions</small>
  </div>

  <!-- Custom Actions Tools Panel -->
  <ng-container *ngIf="tableParams.customActionsLabel">
    <p-panel [header]="tableParams.customActionsLabel">
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('syncPricePoints')">
        <div *ngFor="let env of environments" class="responsive-button-container">
          <p-button (onClick)="syncStoreV2AndPricePoints(env)" styleClass="p-button-responsive">
            <i class="fa-solid fa-cloud-arrow-down p-mr-2"></i>
            Sync Records from Admin Panel <strong class="p-ml-2">{{(env | uppercase)}}</strong>
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('syncStoreListings')">
        <div *ngFor="let env of environments" class="responsive-button-container">
          <p-button (onClick)="syncStoreV2AndPricePoints(env)" styleClass="p-button-responsive">
            <i class="fa-solid fa-cloud-arrow-down p-mr-2"></i>
            Sync Records from Admin Panel <strong class="p-ml-2">{{(env | uppercase)}}</strong>
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('addToCart') &&
      tableParams?.customActionButtons?.includes('syncPricePoints')">
        <div class="responsive-button-container">
          <p-button (onClick)="addToCart('price-points')" styleClass="p-button-responsive">
            <i class="fa-solid fa-cart-shopping p-mr-2"></i>
            Add Selected PricePoints to Cart
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('addToCart') &&
      tableParams?.customActionButtons?.includes('syncStoreListings')">
        <div class="responsive-button-container">
          <p-button (onClick)="addToCart('store-listings')" styleClass="p-button-responsive">
            <i class="fa-solid fa-cart-shopping p-mr-2"></i>
            Add Selected Store Listings to Cart
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('viewDifferencesStore')">
        <div class="responsive-button-container">
          <p-button [disabled]="selectedRows.length < 1" (onClick)="viewDifferences('store-listings')"
            styleClass="p-button-responsive">
            <i class="fa-solid fa-search p-mr-2"></i>
            View Differences
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams.customActionButtons?.includes('viewDifferencesPrice')">
        <div class="responsive-button-container">
          <p-button [disabled]="selectedRows.length < 1" (onClick)="viewDifferences('price-points')"
            styleClass="p-button-responsive">
            <i class="fa-solid fa-search p-mr-2"></i>
            View Differences
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('importQuestions')">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button label="Import Questions" icon="pi pi-upload" styleClass="p-button-responsive p-mr-2"
              (onClick)="showImportQuestions = true">
            </p-button>
          </div>
        </div>
        <app-questions-bulk-import [(visible)]="showImportQuestions"></app-questions-bulk-import>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('importAnswers')">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button label="Import Answers" icon="pi pi-upload" styleClass="p-button-responsive p-mr-2"
              (onClick)="showImportAnswers = true">
            </p-button>
          </div>
        </div>
        <app-answers-bulk-import [(visible)]="showImportAnswers"></app-answers-bulk-import>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('importCollections')">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button label="Import from CSV" icon="pi pi-upload" styleClass="p-button-responsive p-mr-2"
              (onClick)="showImportCollections = true">
            </p-button>
          </div>
        </div>
        <app-collections-bulk-import [(visible)]="showImportCollections"></app-collections-bulk-import>
      </ng-container>
      <ng-container
        *ngIf="tableParams.customActionButtons?.includes('bulkLocalize') && tableParams?.localizeCollectionName">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button [disabled]="selectedRows.length < 1" (onClick)="bulkLocalize(tableParams?.localizeCollectionName)"
              styleClass="p-button-responsive p-mr-2">
              <i class="fa-solid fa-language p-mr-2"></i>
              Localize with AI
            </p-button>
          </div>
          <div class="responsive-button-container" *ngIf="entity === 'challenges'">
            <p-button label="AI Tag Challenges" icon="pi pi-tags" styleClass="p-button-responsive p-mr-2"
              (onClick)="openAiTagChallengesDialog()">
            </p-button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('findReplaceClientStrings')">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button (onClick)="openFindReplaceDialog()"
              styleClass="p-button-responsive p-mr-2"
              [disabled]="authService.hasRole('ROLE_READ_ONLY')">
              <i class="fa-solid fa-right-left p-mr-2"></i>
              Find &amp; Replace
            </p-button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="tableParams?.customActionButtons?.includes('bulkTranslateGeneralStrings')">
        <div class="p-grid responsive-button-grid">
          <div class="responsive-button-container">
            <p-button [disabled]="selectedRows.length < 1" (onClick)="bulkTranslateGeneralStrings()"
              styleClass="p-button-responsive p-mr-2">
              <i class="fa-solid fa-language p-mr-2"></i>
              Translate with AI
            </p-button>
          </div>
          <div class="responsive-button-container" style="display: flex; align-items: center;">
            <p-checkbox [(ngModel)]="includeVerifiedClientStrings" [binary]="true"
              label="Include verified records">
            </p-checkbox>
          </div>
          <div class="responsive-button-container" style="display: flex; align-items: center;">
            <p-checkbox [(ngModel)]="onlyUntranslatedClientStrings" [binary]="true"
              label="Only untranslated records">
            </p-checkbox>
          </div>
          <div class="responsive-button-container" *ngIf="authService.hasRole('ROLE_ADMIN') || authService.hasRole('ROLE_PROD_PUSH')">
            <p-button [disabled]="selectedRows.length < 1" (onClick)="forceTranslateSelected()"
              styleClass="p-button-responsive p-button-warning p-mr-2">
              <i class="fa-solid fa-triangle-exclamation p-mr-2"></i>
              Force Translate Verified
            </p-button>
          </div>
        </div>
      </ng-container>
    </p-panel>
  </ng-container>

  <!-- Export Tools Panel -->
  <p-panel header="Export Tools (CSV)" *ngIf="!tableParams?.hideExport">
    <div class="p-grid responsive-button-grid">
      <div class="responsive-button-container">
        <p-button label="Current Columns" icon="pi pi-file-excel" class="p-mr-2 p-button-responsive"
          (onClick)="exportToCSV('current')"></p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity === 'challenge-tags'">
        <p-button label="Challenge Tags"
                  icon="pi pi-sync"
                  class="p-mr-2 p-button-responsive"
                  (onClick)="challengeTagsClicked()"
                  [disabled]="isSyncingChallengeTags"
                  [loading]="isSyncingChallengeTags">
        </p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity=='items'">
        <p-button label="Organic Set" icon="pi pi-file-excel" class="p-mr-2 p-button-responsive"
          (onClick)="exportToCSV('organic')"></p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity=='items'">
        <p-button label="Hard Surface Set" icon="pi pi-file-excel" class="p-mr-2 p-button-responsive"
          (onClick)="exportToCSV('hard-surface')"></p-button>
      </div>
    </div>
  </p-panel>

  <!-- Editing Tools Panel -->
  <p-panel header="Bulk Actions" *ngIf="!authService.hasRole('ROLE_READ_ONLY') && canBulkUpdate && !tableParams?.hideBulkActions">
    <div class="p-grid responsive-button-grid">
      <div class="responsive-button-container">
        <p-button [disabled]="!areRowsSelected" [label]="'Edit Selected '+entity" icon="pi pi-pencil"
          class="p-mr-2 p-button-responsive" (onClick)="toggleBulkEdit()"></p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity=='items'">
        <p-button [disabled]="!areRowsSelected" [label]="'Add Selected '+entity+' to Collection'"
          icon="pi pi-plus" class="p-button-responsive" (onClick)="toggleAddItemsToCollection('items')"></p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity=='challenges'">
        <p-button [disabled]="!areRowsSelected" [label]="'Add Selected '+entity+' to Collection'"
          icon="pi pi-plus" class="p-button-responsive" (onClick)="toggleAddItemsToCollection('challenges')"></p-button>
      </div>
      <div class="responsive-button-container" *ngIf="entity=='items'">
        <p-button [disabled]="!areRowsSelected" [label]="'Add Selected '+entity+' to Item Set'" icon="pi pi-plus"
          class="p-ml-2 p-button-responsive" (onClick)="toggleAddItemsToItemSet()"></p-button>
      </div>
      <div class="responsive-button-container">
        <p-button [disabled]="!areRowsSelected" [label]="'Duplicate Selected '+entity+' rows'" icon="pi pi-copy"
          class="p-ml-2 p-button-responsive" (onClick)="toggleDuplicate()"></p-button>
      </div>
    </div>
  </p-panel>

  <!-- Build Tools Panel -->
  <p-panel header="Build Tools" *ngIf="!tableParams?.hideBuild">
    <div class="p-grid responsive-button-grid">
      <div class="responsive-button-container" *ngIf="buildParams.assetKeys">
        <small class="p-d-inline p-mr-2">
          Render Asset?
          <i pTooltip="Renders the asset once it has been successfully built, and a slack notification is sent to preview the asset."
            class="pi pi-info-circle" style="font-size: 12px"></i>
        </small>
        <p-inputSwitch class="p-d-inline p-mt-2 p-mr-3" [(ngModel)]="buildAndRender"></p-inputSwitch>
      </div>
      <div class="responsive-button-container">
        <p-button *ngIf="buildParams.assetKeys" [disabled]="!areRowsSelected" class="p-mx-2 p-button-responsive"
          (onClick)="onStartBulkBuild(true)">
          <i class="fab fa-unity p-mr-1"></i>{{'Build Selected '+entity+' Assets'}}
        </p-button>
      </div>
      <div class="responsive-button-container">
        <p-button *ngIf="buildParams.imageKeys" [disabled]="!areRowsSelected" class="p-mx-2 p-button-responsive"
          (onClick)="onStartBulkBuild(false)">
          <i class="fab fa-unity p-mr-1"></i>{{'Build Selected '+entity+' Images'}}
        </p-button>
      </div>
      <div class="responsive-button-container" *ngIf="buildParams.assetKeys">
        <p-button [disabled]="!areRowsSelected" class="p-mx-2 p-button-responsive" (onClick)="showRenderDiffDialog()">
          <i class="fa-solid fa-plus-minus p-mr-2"></i>{{'Render Diff Check for selected assets'}}
        </p-button>
      </div>
      <div class="responsive-button-container" *ngIf="buildParams.assetKeys">
        <p-button [disabled]="!areRowsSelected" class="p-mx-2 p-button-responsive"
          (onClick)="requestBulkAssetStatusCheck('promotion-status')">
          <i class="fa-solid fa-folder-tree p-mr-2"></i>{{'Check Promotion Status for selected assets'}}
        </p-button>
      </div>
      <div class="responsive-button-container" *ngIf="bulkBuild.failedPayloads.length > 0">
        <p-button pRipple icon="pi pi-exclamation-circle" label="Failed Payloads"
          styleClass="p-button-danger p-mx-5 p-button-responsive" (click)="onShowFailedPayloads()">
        </p-button>
      </div>
    </div>
  </p-panel>

  <!-- Promotion Tools Panel -->
  <p-panel header="Promotion Tools" *ngIf="!tableParams?.hidePromotion">
    <div class="p-grid responsive-button-grid">
      <div class="responsive-button-container">
        <p-button *ngIf="buildParams.assetKeys" [disabled]="!areRowsSelected" class="p-mr-2 p-button-responsive"
          (onClick)="startBulkPromotion(true)">
          <i class="fa-solid fa-circle-up p-mr-2"></i>{{'Promote Selected '+entity+' Assets'}}
        </p-button>
      </div>
      <div class="responsive-button-container">
        <p-button *ngIf="buildParams.imageKeys" [disabled]="!areRowsSelected" class="p-mr-2 p-button-responsive"
          (onClick)="startBulkPromotion(false)">
          <i class="fa-regular fa-circle-up p-mr-2"></i>{{'Promote Selected '+entity+' Images'}}
        </p-button>
      </div>
      <div class="responsive-button-container">
        <p-button *ngIf="buildParams.combinedPromotion && buildParams.assetKeys && buildParams.imageKeys"
          [disabled]="!areRowsSelected" class="p-mr-2 p-button-responsive" (onClick)="startCombinedBulkPromotion()">
          <i class="fa-solid fa-cloud-upload-alt p-mr-2"></i>{{'Promote Selected '+entity+' Assets &amp; Images'}}
        </p-button>
      </div>
    </div>
  </p-panel>

  <!-- ACTIONS: 'Render Options' panel -->
  <bulk-render-assets *ngIf="buildParams.renderBuildType" [selectedRecords]="selectedRows"
    [entityType]="buildParams.renderBuildType">
  </bulk-render-assets>
</p-dialog>

<!-- BULK EDIT DIALOG -->
<p-dialog [(visible)]="bulkEditDialogVisible" header="Bulk Edit" modal="true" [draggable]="true" [resizable]="true"
  [closable]="true" (onHide)="cancelBulkEdit()" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '55vw' }">

  <p-steps [model]="bulkEditSteps" [activeIndex]="bulkEditStep" [readonly]="true" styleClass="p-mb-4"></p-steps>

  <!-- Step 1: Field selection -->
  <div *ngIf="bulkEditState === 'select-column'">
    <h5 class="p-mb-3">Select a column to bulk edit</h5>
    <p-listbox [options]="bulkUpdateColDefs" [(ngModel)]="selectedBulkEditColumns" [multiple]="true" [filter]="true"
      optionLabel="name" filterPlaceHolder="Search by Field Name"
      [listStyle]="{'min-height': '300px', 'max-height': '350px'}">
      <ng-template let-option pTemplate="item">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <strong>{{option.name}}</strong>
          <p-tag [value]="option.type" [severity]="getFieldTypeSeverity(option.type)"></p-tag>
        </div>
      </ng-template>
    </p-listbox>
  </div>

  <!-- Step 2: Edit type cards -->
  <div *ngIf="bulkEditState === 'select-edit-type'">
    <h5 class="p-mb-3">Select an edit type</h5>
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem; align-items: stretch;">
      <div *ngFor="let option of editTypes"
        (click)="editType = option"
        style="position: relative; cursor: pointer; border-radius: 6px; padding: 1rem; border: 2px solid; display: flex; flex-direction: column;"
        [style.border-color]="editType?.value === option.value ? 'var(--primary-color)' : 'var(--surface-border)'"
        [style.box-shadow]="editType?.value === option.value ? '0 0 0 1px var(--primary-color)' : 'none'"
        [style.background]="editType?.value === option.value ? 'var(--surface-hover)' : 'var(--surface-card)'">
        <i *ngIf="editType?.value === option.value" class="pi pi-check-circle"
           style="position: absolute; top: 0.5rem; right: 0.5rem; color: var(--primary-color); font-size: 1rem;"></i>
        <div style="margin-bottom: 0.4rem;">
          <i class="fa {{option.icon}}" aria-hidden="true" style="margin-right: 0.5rem;"></i>
          <strong>{{option.label}}</strong>
        </div>
        <small style="color: var(--text-color-secondary);">{{option.description}}</small>
      </div>
    </div>
  </div>

  <!-- Step 3: Edit values -->
  <div *ngIf="bulkEditState === 'edit-values'">
    <div style="display: flex; align-items: center; gap: 0.75rem; padding: 0.75rem 1rem; background: var(--surface-section); border-radius: 6px; margin-bottom: 1rem; border-left: 3px solid var(--primary-color);">
      <i class="fa {{editType.icon}}" style="font-size: 1.1rem; color: var(--primary-color);"></i>
      <div>
        <strong>{{editType.label}}</strong>
        <small style="display: block; color: var(--text-color-secondary); margin-top: 0.15rem;">{{editType.description}}</small>
      </div>
    </div>
    <app-bulk-edit-input #bulkEditInput [editType]="editType" [inputColumn]="getSelectedColumn()"
      [inputColumnDef]="getSelectedColumnDef()" [parentComponent]="parentAgGridTable"></app-bulk-edit-input>
  </div>

  <!-- Step 4: Preview -->
  <div *ngIf="bulkEditState === 'verify-changes'">
    <!-- Compact summary row -->
    <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem; flex-wrap: wrap;">
      <span style="color: var(--text-color-secondary); font-size: 0.875rem;">Editing</span>
      <p-tag [value]="selectedBulkEditColumns[0].name" severity="info"></p-tag>
      <i class="pi pi-arrow-right" style="color: var(--text-color-secondary); font-size: 0.75rem;"></i>
      <p-tag [value]="editType.label" severity="warning"></p-tag>
      <span style="color: var(--text-color-secondary); font-size: 0.875rem;">on</span>
      <p-tag [value]="changeKeys.length + ' rows'" severity="success"></p-tag>
    </div>

    <!-- percentageChange extra info -->
    <div *ngIf="editType.value == 'percentageChange' && tmpInputValue?.direction && tmpInputValue?.value"
      style="margin-bottom: 1rem; padding: 0.5rem 1rem; background: var(--surface-section); border-radius: 6px;">
      <span style="margin-right: 1rem;"><strong>Direction:</strong> {{tmpInputValue.direction}}</span>
      <span><strong>Value:</strong> {{tmpInputValue.value}}%</span>
    </div>

    <!-- Progress bar (only during submission) -->
    <div *ngIf="submitInProgress" class="p-mb-3">
      <p-progressBar [value]="progress"></p-progressBar>
      <small class="p-ml-1">{{ successfulEdits.length }} / {{ changeKeys.length }} rows updated</small>
    </div>

    <!-- Toolbar above table -->
    <div style="display: flex; justify-content: flex-end; margin-bottom: 0.5rem;">
      <p-button label="Remove Selected Rows" icon="pi pi-trash"
        styleClass="p-button-outlined p-button-danger p-button-sm"
        (click)="removeSelectedRows()"></p-button>
    </div>

    <p-table styleClass="p-datatable-sm p-datatable-striped" [value]="changeKeys" [paginator]="true"
      [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" paginatorDropdownAppendTo="body">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem;"></th>
          <th>ID</th>
          <th *ngIf="submitInProgress || progress === 100">Status</th>
          <th><p-tag value="Original Value" severity="warning"></p-tag></th>
          <th><p-tag value="New Value" severity="success"></p-tag></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-id>
        <tr>
          <td>
            <p-checkbox [(ngModel)]="changesPreview[id].selected" [binary]="true" (onChange)="updateSelectedRows()"></p-checkbox>
          </td>
          <td>{{ id }}</td>
          <td *ngIf="submitInProgress || progress === 100">
            <i *ngIf="rowStatus[id] === 'pending'" class="pi pi-circle" style="color: var(--text-color-secondary)" title="Pending"></i>
            <i *ngIf="rowStatus[id] === 'saving'" class="pi pi-spin pi-spinner" style="color: var(--primary-color)" title="Saving…"></i>
            <i *ngIf="rowStatus[id] === 'done'" class="pi pi-check-circle" style="color: var(--green-500)" title="Saved"></i>
            <i *ngIf="rowStatus[id] === 'error'" class="pi pi-times-circle" style="color: var(--red-500)" title="Error"></i>
          </td>
          <ng-container *ngIf="selectedBulkEditColumns[0].type === 'rich-text'; else notRichText">
            <td [innerHTML]="getSafeHtml(changesPreview[id].original)"></td>
            <td [innerHTML]="getSafeHtml(changesPreview[id].new)"></td>
          </ng-container>
          <ng-template #notRichText>
            <ng-container *ngIf="selectedBulkEditColumns[0].type === 'line-items'; else notLineItem">
              <td>
                <div *ngFor="let v of changesPreview[id].original; let index = index" [ngStyle]="{ minWidth: '200px' }"
                  class="p-d-flex p-flex-column">
                  <div class="p-ai-center cost-container {{ changesPreview[id].original.length > index + 1 ? 'p-pb-1' : '' }}">
                    <span class="p-ml-2"
                      style="background-color: var(--text-color); border-radius: 14%; padding: 1px 5px; font-weight: 700; line-height: 21.25px; font-size: 12px; color: var(--primary-color-text); text-align: center; margin-right: 6px; vertical-align: middle;">
                      <strong class="p-m-auto"> {{ v.c | number }} </strong>
                    </span>
                    <div *ngIf="v.lineItemType == 'Item'; else nonItem">
                      <a pButton aria-label="{{ v.id.name }}" [label]="v.id.name+' ('+v.id.id+')'" target="_blank"
                        type="button" class="p-button-link p-text-left" routerLink="/items/{{ v.id.id }}"></a>
                    </div>
                    <ng-template #nonItem> {{ v && v.id && v.id.name ? v.id.name : null }} </ng-template>
                  </div>
                </div>
              </td>
              <td>
                <div *ngFor="let v of changesPreview[id].new; let index = index" [ngStyle]="{ minWidth: '200px' }"
                  class="p-d-flex p-flex-column">
                  <div class="p-ai-center cost-container {{ changesPreview[id].new.length > index + 1 ? 'p-pb-1' : '' }}">
                    <span class="p-ml-2"
                      style="background-color: var(--text-color); border-radius: 14%; padding: 1px 5px; font-weight: 700; line-height: 21.25px; font-size: 12px; color: var(--primary-color-text); text-align: center; margin-right: 6px; vertical-align: middle;">
                      <strong class="p-m-auto"> {{ v.c | number }} </strong>
                    </span>
                    <div *ngIf="v.lineItemType == 'Item'; else nonItem">
                      <a pButton aria-label="{{ v.id.name }}" [label]="v.id.name+' ('+v.id.id+')'" target="_blank"
                        type="button" class="p-button-link p-text-left" routerLink="/items/{{ v.id.id }}"></a>
                    </div>
                    <ng-template #nonItem> {{ v && v.id && v.id.name ? v.id.name : null }} </ng-template>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-template #notLineItem>
              <ng-container *ngIf="selectedBulkEditColumns[0].type === 'multiselect'; else notMultiselect">
                <ng-container *ngIf="selectedBulkEditColumns[0].isFlatList; else notFlat">
                  <ng-container *ngIf="changesPreview[id].original">
                    <td>
                      <span style="text-decoration: line-through; color: var(--text-color-secondary)">
                        <ng-container *ngFor="let flatVal of changesPreview[id].original">{{flatVal}},</ng-container>
                      </span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="changesPreview[id].new !== undefined">
                    <td>
                      <span *ngIf="!isEmptyNewValue(id)" style="color: var(--primary-color); font-weight: 600">
                        <ng-container *ngFor="let flatVal of changesPreview[id].new">{{flatVal}},</ng-container>
                      </span>
                      <span *ngIf="isEmptyNewValue(id)" style="color: var(--text-color-secondary); font-style: italic;">—</span>
                    </td>
                  </ng-container>
                </ng-container>
                <ng-template #notFlat>
                  <td>
                    <ng-container *ngIf="changesPreview[id]?.original">
                      <span style="text-decoration: line-through; color: var(--text-color-secondary)">
                        <ng-container *ngFor="let objVal of changesPreview[id].original">{{objVal.name}} ({{objVal.id}}),<br></ng-container>
                      </span>
                    </ng-container>
                  </td>
                  <td>
                    <span *ngIf="changesPreview[id]?.new && !isEmptyNewValue(id)" style="color: var(--primary-color); font-weight: 600">
                      <ng-container *ngFor="let objVal of changesPreview[id].new">{{objVal.name}} ({{objVal.id}}),<br></ng-container>
                    </span>
                    <span *ngIf="isEmptyNewValue(id)" style="color: var(--text-color-secondary); font-style: italic;">—</span>
                  </td>
                </ng-template>
              </ng-container>
              <ng-template #notMultiselect>
                <td>
                  <span style="text-decoration: line-through; color: var(--text-color-secondary)">{{ formatValue(changesPreview[id].original) }}</span>
                </td>
                <td>
                  <span *ngIf="!isEmptyNewValue(id)" style="color: var(--primary-color); font-weight: 600">{{ formatValue(changesPreview[id].new) }}</span>
                  <span *ngIf="isEmptyNewValue(id)" style="color: var(--text-color-secondary); font-style: italic;">—</span>
                </td>
              </ng-template>
            </ng-template>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-footer>
    <p-button *ngIf="bulkEditState !== 'select-column'" [disabled]="submitInProgress" label="Back"
      icon="pi pi-arrow-left" styleClass="p-button-warning" (onClick)="goBack()">
    </p-button>

    <p-button *ngIf="bulkEditState !== 'verify-changes'" [disabled]="submitInProgress" label="Next"
      icon="pi pi-arrow-right" styleClass="p-button-success" (onClick)="goNext()">
    </p-button>

    <p-button *ngIf="bulkEditState === 'verify-changes'" [disabled]="submitInProgress" label="Submit Changes"
      icon="pi pi-arrow-right" styleClass="p-button-success" (onClick)="submitBulkEdit()">
    </p-button>

    <p-button label="Cancel" [disabled]="submitInProgress" icon="pi pi-times" styleClass="p-button-danger"
      class="p-ml-3" (onClick)="cancelBulkEdit()">
    </p-button>
  </p-footer>
</p-dialog>

<!-- ADD TO COLLECTION DIALOG -->
<p-dialog
  header="Add to Collection"
  [(visible)]="addToCollectionDialogVisible"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
  styleClass="collection-dialog"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
>
  <div class="collection-dialog-body">
    <p class="collection-dialog-prompt">Do you wish to add these items to a collection?</p>
    <p-dropdown
      #collectionDropdown
      *ngIf="collections && collections.length > 0"
      [options]="collections"
      [(ngModel)]="selectedCollection"
      optionLabel="name"
      optionValue="id"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      placeholder="Select a Collection"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="1300"
      panelStyleClass="collection-dropdown-panel"
      styleClass="collection-dialog-dropdown"
      (onShow)="onCollectionDropdownShow()"
    >
      <ng-template let-collection pTemplate="item">
        <div>{{ collection.name }} - ({{ collection.id }})</div>
      </ng-template>
    </p-dropdown>
  </div>

  <ng-template pTemplate="footer">
    <div class="collection-dialog-footer">
      <p-button
        icon="pi pi-times"
        (click)="addToCollectionDialogVisible = false"
        label="Cancel"
        styleClass="p-button-sm p-button-danger"
      ></p-button>
      <p-button
        icon="pi pi-plus"
        (click)="createCollectionDialogVisible = true"
        label="Create New Collection and Add"
        styleClass="p-button-sm p-button-warning"
      ></p-button>
      <p-button
        icon="pi pi-arrow-right"
        [disabled]="!selectedCollection"
        label="Add to Collection"
        (click)="addToCollection()"
        styleClass="p-button-sm"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- CREATE COLLECTION & ADD TO COLLECTION DIALOG -->
<p-dialog
  header="Create Collection"
  [(visible)]="createCollectionDialogVisible"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  [style]="{ width: '28rem', maxWidth: '95vw' }"
  styleClass="collection-dialog"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
>
  <div class="collection-dialog-body">
    <label class="collection-dialog-label" for="createCollectionName">Collection Name</label>
    <input
      id="createCollectionName"
      [(ngModel)]="createCollection.name"
      [ngModelOptions]="{ standalone: true }"
      pInputText
      class="collection-dialog-input"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="collection-dialog-footer">
      <p-button
        icon="pi pi-times"
        (click)="createCollectionDialogVisible = false"
        label="Cancel"
        styleClass="p-button-sm p-button-danger"
      ></p-button>
      <p-button
        icon="pi pi-plus"
        (click)="createAndAddToCollection()"
        label="Create and Add Collection"
        styleClass="p-button-sm"
        [disabled]="isCreatingCollection"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- ADD TO ITEM SET DIALOG -->
<p-dialog
  header="Add to Item Set"
  [(visible)]="addToItemSetDialogVisible"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
  styleClass="collection-dialog action-dialog"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
>
  <div class="collection-dialog-body">
    <p class="collection-dialog-prompt">Do you wish to add these items to an Item Set?</p>
    <p-dropdown
      *ngIf="itemSets && itemSets.length > 0"
      [options]="itemSets"
      [(ngModel)]="selectedItemSet"
      optionLabel="name"
      optionValue="id"
      [filter]="true"
      filterBy="name"
      [showClear]="true"
      placeholder="Select an Item Set"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="1300"
      styleClass="collection-dialog-dropdown"
    >
      <ng-template let-itemSet pTemplate="item">
        <div>{{ itemSet.name }} - ({{ itemSet.id }})</div>
      </ng-template>
    </p-dropdown>
  </div>

  <ng-template pTemplate="footer">
    <div class="collection-dialog-footer action-dialog-footer">
      <p-button
        icon="pi pi-times"
        (click)="addToItemSetDialogVisible = false"
        label="Cancel"
        styleClass="p-button-sm p-button-danger"
      ></p-button>
      <p-button
        icon="pi pi-plus"
        (click)="createItemSetDialogVisible = true"
        label="Create New Item Set and Add"
        styleClass="p-button-sm p-button-warning"
      ></p-button>
      <p-button
        icon="pi pi-arrow-right"
        [disabled]="!selectedItemSet"
        label="Add to Item Set"
        (click)="addToItemSet()"
        styleClass="p-button-sm"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- CREATE ITEM SET & ADD TO ITEM SET DIALOG -->
<p-dialog
  header="Create Item Set"
  [(visible)]="createItemSetDialogVisible"
  [modal]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  [style]="{ width: '28rem', maxWidth: '95vw' }"
  styleClass="collection-dialog action-dialog"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
>
  <div class="collection-dialog-body">
    <label class="collection-dialog-label" for="createItemSetName">Item Set Name</label>
    <input
      id="createItemSetName"
      [(ngModel)]="createItemSet.name"
      [ngModelOptions]="{ standalone: true }"
      pInputText
      class="collection-dialog-input"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="collection-dialog-footer action-dialog-footer">
      <p-button
        icon="pi pi-times"
        (click)="createItemSetDialogVisible = false"
        label="Cancel"
        styleClass="p-button-sm p-button-danger"
      ></p-button>
      <p-button
        icon="pi pi-plus"
        (click)="createAndAddToItemSet()"
        label="Create and Add Item Set"
        styleClass="p-button-sm"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- BULK BUILD DIALOG -->
<p-dialog
  header="Send {{ bulkBuild.rows.length }} {{ entity }} to Build Queue?"
  [(visible)]="showBulkBuild"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '48rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-dialog-scroll">
    <p-table
      [value]="bulkBuild.rows"
      styleClass="p-datatable-sm action-dialog-table"
      responsiveLayout="stack"
      breakpoint="768px"
    >
      <ng-template pTemplate="header">
        <tr class="p-text-uppercase">
          <th>ID</th>
          <th>Name</th>
          <th>Path(s)</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td><span class="p-column-title">ID</span>{{ item.id }}</td>
          <td><span class="p-column-title">Name</span>{{ item.name }}</td>
          <td>
            <span class="p-column-title">Path(s)</span>
            <ul class="action-path-list">
              <li *ngFor="let jobData of item.buildJobData">{{ jobData.path }}</li>
            </ul>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="action-dialog-footer">
      <div class="action-dialog-progress" *ngIf="showBuildProgress">
        <p-progressBar [value]="bulkBuildProgress"></p-progressBar>
      </div>
      <button
        pButton
        pRipple
        type="button"
        label="Cancel"
        icon="pi pi-times"
        class="p-button-outlined"
        (click)="showBulkBuild = false; showBuildProgress = false"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Build"
        icon="pi pi-check"
        [disabled]="disableBuildButton"
        (click)="buildMiscAsset()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Build with new hash"
        icon="pi pi-check"
        [disabled]="disableBuildButton"
        (click)="buildMiscAsset(true)"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- BULK BUILD DIALOG FAILED PAYLOADS -->
<p-dialog
  *ngIf="bulkBuild.failedPayloads && bulkBuild.failedPayloads.length > 0"
  header="Failed Payloads"
  [(visible)]="showBulkBuildFailed"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '52rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-user-meta">
    <div class="action-user-meta-label">USER DATA</div>
    <div><strong>Name:</strong> {{ bulkBuild.failedPayloads[0].user.name || 'empty' }}</div>
    <div><strong>Email:</strong> {{ bulkBuild.failedPayloads[0].user.email || 'empty' }}</div>
    <div><strong>ID:</strong> {{ bulkBuild.failedPayloads[0].user.id || 'empty' }}</div>
  </div>

  <div class="action-dialog-scroll">
    <p-table
      [value]="bulkBuild.failedPayloads"
      styleClass="p-datatable-sm action-dialog-table"
      responsiveLayout="stack"
      breakpoint="768px"
    >
      <ng-template pTemplate="header">
        <tr class="p-text-uppercase">
          <th>ID</th>
          <th>Build Type</th>
          <th>Path</th>
          <th>Error Type</th>
          <th>Error Message</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-payload>
        <tr>
          <td><span class="p-column-title">ID</span>{{ payload.entityId || 'empty' }}</td>
          <td><span class="p-column-title">Build Type</span>{{ payload.buildType || 'empty' }}</td>
          <td><span class="p-column-title">Path</span>{{ payload.path || 'empty' }}</td>
          <td [ngStyle]="payload._error?.Type ? { color: 'orange' } : { color: 'red', fontWeight: 'bold' }">
            <span class="p-column-title">Error Type</span>{{ payload._error?.Type || 'unknown' }}
          </td>
          <td><span class="p-column-title">Error Message</span>{{ payload._error?.Message || '' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- BULK Promote Dialog -->
<p-dialog
  header="Promote {{ bulkPromote.rows.length }} {{ isCombinedPromotion ? 'assets &amp; images' : (isAssetPromotion ? 'assets' : 'images') }}?"
  [(visible)]="showBulkPromote"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '48rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-dialog-scroll">
    <p-table
      [value]="bulkPromote.rows"
      styleClass="p-datatable-sm action-dialog-table"
      responsiveLayout="stack"
      breakpoint="768px"
    >
      <ng-template pTemplate="header">
        <tr class="p-text-uppercase">
          <th>ID</th>
          <th>Name</th>
          <th>Path(s)</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td><span class="p-column-title">ID</span>{{ item.id }}</td>
          <td><span class="p-column-title">Name</span>{{ item.name }}</td>
          <td>
            <span class="p-column-title">Path(s)</span>
            <ul class="action-path-list">
              <li *ngFor="let jobData of item.buildJobData">{{ jobData.path }}</li>
            </ul>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="action-dialog-footer">
      <div class="action-dialog-progress" *ngIf="showPromoteProgress">
        <p-progressBar [value]="bulkPromoteProgress"></p-progressBar>
      </div>
      <button
        pButton
        pRipple
        type="button"
        label="Cancel"
        icon="pi pi-times"
        class="p-button-outlined p-button-danger"
        (click)="showBulkPromote = false"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Promote"
        icon="pi pi-cloud-upload"
        [disabled]="disablePromoteButton"
        (click)="onBulkPromotion(isAssetPromotion)"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Promote with new hash"
        pTooltip="Promotes and generates a new hash for gamedata"
        tooltipPosition="top"
        icon="pi pi-cloud-upload"
        [disabled]="disablePromoteButton"
        (click)="onBulkPromotion(isAssetPromotion, true)"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- BULK Promote Failed Promotions Dialog -->
<p-dialog
  *ngIf="bulkPromote.failedPayloads && bulkPromote.failedPayloads.length > 0"
  header="Failed Promotions"
  [(visible)]="showBulkPromoteFailed"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '40rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-dialog-scroll">
    <p-table
      [value]="bulkPromote.failedPayloads"
      styleClass="p-datatable-sm action-dialog-table"
      responsiveLayout="stack"
      breakpoint="768px"
    >
      <ng-template pTemplate="header">
        <tr class="p-text-uppercase">
          <th>ID</th>
          <th>Name</th>
          <th>Error</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-payload>
        <tr>
          <td [ngStyle]="payload.id ? '' : { color: 'red', fontWeight: 'bold' }">
            <span class="p-column-title">ID</span>{{ payload.id || 'empty' }}
          </td>
          <td [ngStyle]="payload.name ? '' : { color: 'red', fontWeight: 'bold' }">
            <span class="p-column-title">Name</span>{{ payload.name || 'empty' }}
          </td>
          <td [ngStyle]="payload.promotionError ? '' : { color: 'red', fontWeight: 'bold' }">
            <span class="p-column-title">Error</span>{{ payload.promotionError || 'empty' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- ENV Diff -->
<p-dialog [(visible)]="differencesModal" [dismissableMask]="true" [modal]="true" [transitionOptions]="'200ms'"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '90vw' }" maximizable="true">
  <ng-template pTemplate="header">
    <div class="header-content">
      <h3>Environment Differences</h3>
    </div>
  </ng-template>
  <div>
    <p-accordion *ngIf="differencesLoaded" [multiple]="true">
      <p-accordionTab *ngFor="let item of differences.records">
        <ng-template pTemplate="header">
          <span>Name: {{findFirstString(item.name)}} <span
              style="cursor: pointer; text-decoration: underline; color: var(--primary-color)"
              (click)="navigateToDetails(item.id, differences.entity == 'store-listings' ? 'store-listings-v2' : 'price-points')">ID:
              {{ item.id }}</span> <p-tag [style]="{background: '#757575'}" *ngIf="!item.isDifferent"
              value="No Difference" icon="pi pi-info-circle"></p-tag></span>
        </ng-template>
        <p-table [value]="item.fields" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem"></th>
              <th pSortableColumn="name">Name <p-sortIcon field="key"></p-sortIcon></th>
              <th pSortableColumn="dev">Dev Value<p-sortIcon field="source_value"></p-sortIcon></th>
              <th pSortableColumn="qa">Qa Value<p-sortIcon field="destination_values"></p-sortIcon></th>
              <th pSortableColumn="prod">Prod Value<p-sortIcon field="destination_values"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td></td>
              <td>{{item.key}}</td>
              <td><data-component [data]="item.dev"></data-component></td>
              <td><data-component [data]="item.qa"></data-component></td>
              <td><data-component [data]="item.prod"></data-component></td>
            </tr>
          </ng-template>
        </p-table>
      </p-accordionTab>
    </p-accordion>
  </div>
</p-dialog>

<!-- DIFF Check Options Dialog -->
<p-dialog
  header="Render Diff Check Options"
  [(visible)]="displayRenderDiffDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-dialog-body">
    <p class="action-dialog-prompt">Number of records selected: {{ selectedRowsSet.size }}</p>

    <div class="action-diff-option">
      <p-radioButton name="simple" value="simple" [(ngModel)]="diffCheckType"></p-radioButton>
      <label class="action-diff-option-label">Simple Diff Check (Report sent via Slack)</label>
    </div>

    <div class="action-diff-option">
      <p-radioButton name="user-submission" value="user-submission" [(ngModel)]="diffCheckType"></p-radioButton>
      <label class="action-diff-option-label">
        User Submission Diff Check (Infinite Gardening validity check)
      </label>
    </div>

    <div class="action-diff-ref" *ngIf="diffCheckType === 'user-submission'">
      <span class="p-float-label">
        <textarea
          id="diff-ref"
          [rows]="3"
          pInputTextarea
          class="collection-dialog-input"
          [(ngModel)]="diffCheckRef"
        ></textarea>
        <label for="diff-ref">Reference text to identify a Diff Job (Optional)</label>
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="action-dialog-footer">
      <p-button
        label="Cancel"
        icon="pi pi-times"
        styleClass="p-button-outlined p-button-danger"
        (onClick)="displayRenderDiffDialog = false"
      ></p-button>
      <p-button
        [disabled]="!areRowsSelected"
        styleClass="p-button-responsive"
        (onClick)="requestBulkAssetStatusCheck('render-diff')"
      >
        <i class="fa-solid fa-plus-minus p-mr-2"></i>
        Trigger Render Diff Check
      </p-button>
    </div>
  </ng-template>
</p-dialog>


<ngx-spinner bdColor="rgba(36,34,36,0.8)" size="medium" color="#81c784" type="line-scale" [fullScreen]="false">
  <h2>Loading...</h2>
</ngx-spinner>




<p-toast></p-toast>

<!-- Bulk Edit Complete success dialog -->
<p-dialog
    [(visible)]="showSuccessDialog"
    [style]="{width: '520px'}"
    [modal]="true"
    [closable]="true"
    (onHide)="closeSuccessDialog()">

  <!-- Success icon -->
  <div style="text-align: center; padding: 1.5rem 1rem 1rem;">
    <div style="position: relative; display: inline-block;">
      <div [style.background]="failedEdits.length ? 'var(--yellow-100)' : 'var(--green-100)'"
        [style.border]="failedEdits.length ? '3px solid var(--yellow-500)' : '3px solid var(--green-500)'"
        style="width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
        <i [class]="failedEdits.length ? 'pi pi-exclamation-triangle' : 'pi pi-check'"
          [style.color]="failedEdits.length ? 'var(--yellow-600)' : 'var(--green-500)'"
          style="font-size: 2rem; font-weight: 900;"></i>
      </div>
      <!-- decorative sparks -->
      <i class="pi pi-star-fill" style="position: absolute; top: -6px; right: -8px; font-size: 0.55rem; color: var(--green-400);"></i>
      <i class="pi pi-star-fill" style="position: absolute; bottom: -4px; left: -10px; font-size: 0.4rem; color: var(--green-300);"></i>
      <i class="pi pi-star-fill" style="position: absolute; top: 4px; left: -12px; font-size: 0.45rem; color: var(--green-500);"></i>
      <i class="pi pi-star-fill" style="position: absolute; bottom: 0; right: -14px; font-size: 0.35rem; color: var(--green-400);"></i>
    </div>
    <h2 style="margin: 1rem 0 0.4rem; font-size: 1.4rem;">
      {{ failedEdits.length ? 'Bulk Edit Partially Complete' : 'Bulk Edit Complete' }}
    </h2>
    <p style="color: var(--text-color-secondary); margin: 0;">
      Successfully updated <strong style="color: var(--green-500);">{{ successfulEdits.length }} rows</strong><span
        *ngIf="failedEdits.length">, <strong style="color: var(--red-500);">{{ failedEdits.length }} failed</strong></span>.
    </p>
  </div>

  <!-- Summary bar -->
  <div style="display: grid; grid-template-columns: 1fr 1px 1fr 1px 1fr; gap: 0; background: var(--surface-section); border: 1px solid var(--surface-border); border-radius: 8px; margin: 0.75rem 1rem 1rem; overflow: hidden;">
    <div style="padding: 0.75rem; text-align: center;">
      <div style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-color-secondary); margin-bottom: 0.3rem;">
        <i class="pi pi-list" style="margin-right: 0.3rem;"></i>Field
      </div>
      <strong style="font-size: 0.875rem; word-break: break-word;">{{ selectedBulkEditColumns[0]?.name }}</strong>
    </div>
    <div style="background: var(--surface-border);"></div>
    <div style="padding: 0.75rem; text-align: center;">
      <div style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-color-secondary); margin-bottom: 0.3rem;">
        <i class="pi pi-pencil" style="margin-right: 0.3rem;"></i>Operation
      </div>
      <strong style="font-size: 0.875rem;">{{ editType?.label }}</strong>
    </div>
    <div style="background: var(--surface-border);"></div>
    <div style="padding: 0.75rem; text-align: center;">
      <div style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-color-secondary); margin-bottom: 0.3rem;">
        <i class="pi pi-users" style="margin-right: 0.3rem;"></i>Rows Affected
      </div>
      <strong style="font-size: 0.875rem; color: var(--green-500);">{{ successfulEdits.length }}</strong>
    </div>
  </div>

  <!-- Updated Records list -->
  <div style="padding: 0 1rem 1rem;">
    <div style="font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-color-secondary); margin-bottom: 0.5rem; font-weight: 600;">
      Updated Records
    </div>
    <div style="border: 1px solid var(--surface-border); border-radius: 6px; max-height: 160px; overflow-y: auto;">
      <div *ngFor="let id of successfulEdits; let last = last"
        style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0.75rem;"
        [style.border-bottom]="last ? 'none' : '1px solid var(--surface-border)'">
        <i class="pi pi-check-circle" style="color: var(--green-500); font-size: 0.875rem;"></i>
        <span style="font-size: 0.875rem;">ID {{ id }}</span>
      </div>
    </div>
  </div>

  <!-- Failed Records list -->
  <div *ngIf="failedEdits.length" style="padding: 0 1rem 1rem;">
    <div style="font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.05em; color: var(--red-500); margin-bottom: 0.5rem; font-weight: 600;">
      Failed Records
    </div>
    <div style="border: 1px solid var(--surface-border); border-radius: 6px; max-height: 160px; overflow-y: auto;">
      <div *ngFor="let failure of failedEdits; let last = last"
        style="display: flex; align-items: flex-start; gap: 0.5rem; padding: 0.5rem 0.75rem;"
        [style.border-bottom]="last ? 'none' : '1px solid var(--surface-border)'">
        <i class="pi pi-times-circle" style="color: var(--red-500); font-size: 0.875rem; margin-top: 0.15rem;"></i>
        <span style="font-size: 0.875rem;">
          <strong>ID {{ failure.id }}</strong>
          <span style="color: var(--text-color-secondary);"> — {{ failure.error }}</span>
        </span>
      </div>
    </div>
  </div>

  <!-- Footer info line -->
  <div style="padding: 0 1rem 0.75rem; color: var(--text-color-secondary); font-size: 0.8rem;">
    <i class="pi pi-info-circle" style="margin-right: 0.35rem;"></i>
    <span *ngIf="!failedEdits.length">All changes have been applied successfully.</span>
    <span *ngIf="failedEdits.length">The failed rows were not changed. You can re-select them and try again.</span>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Done" icon="pi pi-check"
      [styleClass]="failedEdits.length ? 'p-button-warning' : 'p-button-success'"
      (onClick)="closeSuccessDialog()"></p-button>
  </ng-template>
</p-dialog>

<!-- AI Tag Challenges Dialog -->
<p-dialog header="AI Tag Challenges" [(visible)]="showAiTagChallengesDialog" [modal]="true" [style]="{width: '500px'}">
  <div class="p-fluid">
    <div class="p-field p-mb-3">
      <h4 class="p-mb-2" style="color: var(--primary-color);">AI Tagging Actions</h4>
      <div class="p-d-flex p-flex-column p-gap-2">
        <p-button label="Tag Selected Challenges" icon="pi pi-check-circle" styleClass="p-mb-2 p-button-success" [disabled]="!selectedRows || selectedRows.length === 0 || isSyncingAiTagChallenges" [loading]="isSyncingAiTagChallenges" (onClick)="aiTagSelectedChallenges()"></p-button>
        <p-button label="Tag Range of Challenges" icon="pi pi-sliders-h" styleClass="p-mb-2 p-button-info" (onClick)="openRangeTagDialog()"></p-button>
      </div>
    </div>
    <div *ngIf="aiTagChallengesResult" class="p-mt-3">
      <h5 style="color: var(--primary-color);">AI Tagging Result</h5>
      <p-accordion [multiple]="false">
        <p-accordionTab header="Show Result Details">
          <div *ngIf="aiTagChallengesResult.details && aiTagChallengesResult.details.length > 0">
            <div *ngFor="let detail of aiTagChallengesResult.details" class="p-mb-3">
              <div *ngIf="detail.annotated_image_cdn" class="p-mb-2 p-d-flex p-flex-column p-ai-center">
                <img [src]="detail.annotated_image_cdn" alt="Annotated" style="max-width: 100%; border-radius: 8px; box-shadow: 0 2px 8px #0002; margin-bottom: 8px;" />
                <a [href]="detail.annotated_image_cdn" target="_blank" style="color: var(--primary-color); font-size: 0.95em;">View Full Image</a>
              </div>
              <div class="p-mb-2">
                <strong>Detected Classes:</strong>
                <span *ngIf="detail.detected_class_names && detail.detected_class_names.length > 0; else noClasses">
                  <span *ngFor="let className of detail.detected_class_names; let i = index">
                    <span class="p-tag p-mr-1">{{ className }}</span>
                  </span>
                </span>
                <ng-template #noClasses><span style="color: #e57373;">No classes detected</span></ng-template>
              </div>
              <div class="p-mb-2">
                <strong>Detections:</strong>
                <ul *ngIf="detail.detections && detail.detections.length > 0; else noDetections" style="margin: 0; padding-left: 1.2em;">
                  <li *ngFor="let det of detail.detections">
                    <span class="p-tag p-mr-1">{{ det.class_name }}</span>
                    Confidence: {{ det.confidence | number:'1.0-2' }}%
                  </li>
                </ul>
                <ng-template #noDetections><span style="color: #e57373;">No detections</span></ng-template>
              </div>
              <div class="p-mb-2">
                <strong>Stats:</strong>
                <ul style="margin: 0; padding-left: 1.2em;">
                  <li *ngIf="detail.processing_stats">Max Confidence: {{ detail.processing_stats.max_confidence }}</li>
                  <li *ngIf="detail.processing_stats">Avg Confidence: {{ detail.processing_stats.avg_confidence }}</li>
                  <li *ngIf="detail.processing_stats">Unique Classes: {{ detail.processing_stats.unique_classes_count }}</li>
                  <li *ngIf="detail.processing_stats">Threshold: {{ detail.processing_stats.confidence_threshold }}</li>
                  <li *ngIf="!detail.processing_stats" style="color: #e57373;">No stats available</li>
                </ul>
              </div>
              <div class="p-mb-2">
                <strong>Processing Time:</strong> {{ detail.processing_time ? (detail.processing_time | number:'1.2-2') + 's' : 'N/A' }}
              </div>
            </div>
          </div>
          <pre style="max-height: 200px; overflow-y: auto; background: #232323; color: #bfbfbf; border-radius: 6px; padding: 10px;">{{ aiTagChallengesResult | json }}</pre>
        </p-accordionTab>
      </p-accordion>
    </div>
    <div *ngIf="!aiTagChallengesResult && !isSyncingAiTagChallenges" class="p-text-secondary p-mt-2">
      <small>Select challenges and click "Tag Selected Challenges" to start the AI tagging process.</small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Close" (click)="closeAiTagChallengesDialog()" class="p-button-text"></button>
  </ng-template>
</p-dialog>

<!-- Dialog for Range Tagging -->
<p-dialog header="Tag Range of Challenges" [(visible)]="showRangeTagDialog" [modal]="true" [style]="{width: '400px'}">
  <div class="p-fluid">
    <div class="p-field p-mb-3">
      <label for="startId"><strong>Start ID</strong></label>
      <input id="startId" type="number" pInputText [(ngModel)]="rangeStartId" min="1" placeholder="Enter start challenge ID" style="width: 100%;" />
    </div>
    <div class="p-field p-mb-3">
      <label for="endId"><strong>End ID</strong></label>
      <input id="endId" type="number" pInputText [(ngModel)]="rangeEndId" min="1" placeholder="Enter end challenge ID" style="width: 100%;" />
    </div>
    <div *ngIf="rangeTagError" class="p-error p-mb-2">{{ rangeTagError }}</div>
    <div class="p-d-flex p-jc-end">
      <p-button label="Tag Range" icon="pi pi-check" styleClass="p-button-success" [disabled]="!rangeStartId || !rangeEndId || isSyncingRangeTag" [loading]="isSyncingRangeTag" (onClick)="tagRangeOfChallenges()"></p-button>
    </div>
  </div>
</p-dialog>

<!-- Dialog for Range Tagging Result JSON -->
<p-dialog header="Range Tagging Result" [(visible)]="showRangeTagResultDialog" [modal]="true" [style]="{width: '600px'}">
  <div class="p-fluid">
    <pre style="max-height: 400px; overflow-y: auto; background: #232323; color: #bfbfbf; border-radius: 6px; padding: 10px;">{{ rangeTagResult | json }}</pre>
  </div>
  <ng-template pTemplate="footer">
    <button pButton label="Close" (click)="showRangeTagResultDialog = false" class="p-button-text"></button>
  </ng-template>
</p-dialog>

<!-- DUPLICATE BUILD CONFIRMATION DIALOG -->
<p-dialog
  header="Building Duplicated Build Records"
  [(visible)]="showDupConfirmDialog"
  [modal]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="{ '960px': '92vw', '640px': '95vw' }"
  [style]="{ width: '40rem', maxWidth: '95vw' }"
  styleClass="action-dialog"
>
  <div class="action-dialog-warning">
    <i class="pi pi-exclamation-triangle" style="font-size: 1.4rem; color: var(--yellow-500); flex-shrink: 0"></i>
    <span>
      <strong>{{ dupFailuresForConfirm.length }} build(s)</strong> were blocked because they share a path with assets
      owned by other challenges. Building will overwrite the shared file for those challenges.
    </span>
  </div>

  <div class="action-dialog-scroll">
    <p-table
      [value]="dupFailuresForConfirm"
      styleClass="p-datatable-sm action-dialog-table"
      responsiveLayout="stack"
      breakpoint="768px"
    >
      <ng-template pTemplate="header">
        <tr class="p-text-uppercase">
          <th>Path</th>
          <th>Conflicts With</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-failed>
        <tr>
          <td style="word-break: break-all;">
            <span class="p-column-title">Path</span>{{ failed.path }}
          </td>
          <td>
            <span class="p-column-title">Conflicts With</span>
            <span *ngFor="let dup of failed._error?.DupID; let last = last">
              <a
                href="/challenges/{{ dup.assetReferenceId }}"
                target="_blank"
                style="color: var(--primary-color)"
              >{{ dup.assetReferenceId }}</a><span *ngIf="!last">, </span>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="action-dialog-footer">
      <button
        pButton
        pRipple
        type="button"
        label="Cancel"
        icon="pi pi-times"
        class="p-button-outlined"
        (click)="onDupConfirmReject()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Build Anyway"
        icon="pi pi-check"
        class="p-button-warning"
        (click)="onDupConfirmAccept()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="findReplaceDialogVisible"
  header="Find &amp; Replace"
  modal="true"
  [draggable]="true"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: findReplaceDialogWidth }"
  (onHide)="closeFindReplaceDialog()"
>
  <div *ngIf="findReplaceStep === 'form'" style="display:flex; flex-direction:column; gap:1rem;">
    <div>
      <label for="findReplaceFind" style="display:block; font-weight:600; margin-bottom:0.35rem;">Find</label>
      <input
        pInputText
        id="findReplaceFind"
        [(ngModel)]="findReplaceFind"
        placeholder="Text to search for"
        style="width:100%;"
      />
    </div>
    <div>
      <label for="findReplaceReplace" style="display:block; font-weight:600; margin-bottom:0.35rem;">Replace with</label>
      <input
        pInputText
        id="findReplaceReplace"
        [(ngModel)]="findReplaceReplace"
        placeholder="Replacement text (leave empty to remove)"
        style="width:100%;"
      />
    </div>
    <div>
      <label style="display:block; font-weight:600; margin-bottom:0.35rem;">Match mode</label>
      <p-selectButton
        [options]="findReplaceMatchModeOptions"
        [(ngModel)]="findReplaceMatchMode"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>
    <div>
      <label style="display:block; font-weight:600; margin-bottom:0.35rem;">Languages</label>
      <div style="display:flex; flex-direction:column; gap:0.4rem;">
        <p-checkbox
          *ngFor="let language of findReplaceLanguageOptions"
          [(ngModel)]="findReplaceLanguages"
          [value]="language.value"
          [inputId]="'findReplaceLang-' + language.value"
          [label]="language.label"
        ></p-checkbox>
      </div>
      <small style="display:block; margin-top:0.4rem; color:var(--text-color-secondary);">
        Verified records are skipped unless included.
      </small>
      <div style="margin-top:0.5rem;">
        <p-checkbox
          [(ngModel)]="findReplaceIncludeVerified"
          [binary]="true"
          inputId="findReplaceIncludeVerified"
          label="Include verified records"
        ></p-checkbox>
      </div>
    </div>
  </div>

  <div *ngIf="findReplaceStep === 'preview'">
    <div *ngIf="findReplacePreviewRows.length === 0"
      style="display:flex; flex-direction:column; align-items:center; justify-content:center; padding:2.5rem 1rem; text-align:center; color:var(--text-color-secondary);">
      <i class="pi pi-search" style="font-size:2rem; margin-bottom:0.75rem;"></i>
      <div style="font-weight:600; margin-bottom:0.25rem;">No matching records</div>
      <div>No records match the search criteria.</div>
    </div>

    <ng-container *ngIf="findReplacePreviewRows.length > 0">
      <div *ngIf="findReplaceTruncated"
        style="margin-bottom:1rem; padding:0.75rem; background:var(--yellow-50); border-left:3px solid var(--yellow-500); border-radius:6px;">
        Showing the first {{ findReplaceExpectedIds.length }} of {{ findReplaceTotalRecords }} matching record(s).
        Narrow the search to apply changes.
      </div>
      <div *ngIf="findReplaceSkippedVerified > 0"
        style="margin-bottom:1rem; padding:0.75rem; background:var(--surface-100); border-radius:6px; color:var(--text-color-secondary);">
        {{ findReplaceSkippedVerified }} verified record(s) were skipped. Enable “Include verified records” to update them.
      </div>
      <div style="display:flex; align-items:center; gap:0.5rem; margin-bottom:1rem; flex-wrap:wrap;">
        <span style="color:var(--text-color-secondary); font-size:0.875rem;">Previewing</span>
        <p-tag [value]="findReplaceExpectedIds.length + ' record(s)'" severity="info"></p-tag>
        <p-tag [value]="findReplacePreviewRows.length + ' change(s)'" severity="success"></p-tag>
      </div>
      <p-table
        styleClass="p-datatable-sm p-datatable-striped"
        [value]="findReplacePreviewRows"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        paginatorDropdownAppendTo="body"
        [scrollable]="true"
        scrollHeight="360px"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Record ID</th>
            <th>Language</th>
            <th><p-tag value="Before" severity="warning"></p-tag></th>
            <th><p-tag value="After" severity="success"></p-tag></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              {{ row.id }}
              <p-tag *ngIf="row.verified" value="Verified" severity="warning" styleClass="p-ml-2"></p-tag>
            </td>
            <td>{{ row.languageLabel }}</td>
            <td>{{ row.before }}</td>
            <td>{{ row.after }}</td>
          </tr>
        </ng-template>
      </p-table>
      <div *ngIf="isFindReplaceEnglishSelected"
        style="margin-top:1rem; padding:0.75rem; background:var(--surface-100); border-radius:6px;">
        <p-checkbox
          [(ngModel)]="findReplaceTriggerLocalization"
          [binary]="true"
          inputId="findReplaceTriggerLocalization"
          label="Trigger a localization job after the update is applied"
        ></p-checkbox>
        <small *ngIf="findReplaceTriggerLocalization && findReplaceWillOverwrite"
          style="display:block; margin-top:0.5rem; color:var(--orange-600);">
          Localization will regenerate all non-English values from the new English.
          Non-English replacements on those records will not be applied.
        </small>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div style="display:flex; justify-content:flex-end; gap:0.5rem; width:100%;">
      <p-button
        *ngIf="findReplaceStep === 'form'"
        label="Cancel"
        icon="pi pi-times"
        styleClass="p-button-outlined"
        (onClick)="closeFindReplaceDialog()"
      ></p-button>
      <p-button
        *ngIf="findReplaceStep === 'form'"
        label="Preview Matches"
        icon="pi pi-search"
        [disabled]="!canPreviewFindReplace"
        [loading]="findReplaceLoading"
        (onClick)="previewFindReplace()"
      ></p-button>
      <p-button
        *ngIf="findReplaceStep === 'preview'"
        label="Back"
        icon="pi pi-arrow-left"
        styleClass="p-button-outlined"
        [disabled]="findReplaceLoading"
        (onClick)="backToFindReplaceForm()"
      ></p-button>
      <p-button
        *ngIf="findReplaceStep === 'preview'"
        label="Apply Changes"
        icon="pi pi-check"
        [disabled]="!canApplyFindReplace"
        [loading]="findReplaceLoading"
        (onClick)="applyFindReplace()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
